import { render, staticRenderFns } from "./repsol-table-popup.component.html?vue&type=template&id=2f028b44&external"
import script from "./RepsolTablePopupComponent.vue?vue&type=script&lang=ts"
export * from "./RepsolTablePopupComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports